/** Walkaround videó feldolgozás — backend FRAME_COUNT-tal egyeztetve. */
export const WALKAROUND_FRAME_COUNT = 72;

/** 360° — csak videóból kivágott kockasorozat (string URL lista). */

export function normalize360Frames(images_360) {
  if (!Array.isArray(images_360) || images_360.length === 0) return [];
  if (typeof images_360[0] === "string") {
    return images_360.filter((u) => typeof u === "string" && u.trim());
  }
  if (images_360[0] && typeof images_360[0] === "object" && images_360[0].url) {
    return images_360.map((it) => it?.url).filter((u) => typeof u === "string" && u.trim());
  }
  return [];
}

/** Legalább 2 kocka — megjeleníthető 360° viewer. */
export function has360Viewer(car) {
  return normalize360Frames(car?.images_360).length >= 2;
}

/** Videó-feldolgozás után tipikus minimum (NewListing). */
export function has360VideoFrames(car) {
  return normalize360Frames(car?.images_360).length >= 12;
}
